import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class LoaderIcon extends BaseIcon {
  getChildren = () => [<g>
    <g transform="translate(12 12)">
      <animateTransform attributeName="transform" repeatCount="indefinite" dur="0.833s" keyTimes="0;1" values="12,12;12,12"/>
      <animateTransform attributeName="transform" additive="sum" type="rotate" repeatCount="indefinite" dur="0.833s" keyTimes="0;.95;1"
                        values="0,0,0;360,0,0;360,0,0"/>
      <path stroke={ this.getColor() } strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" fill="none"
            d="M-.05 10Q-4.15 10 -7.1 7.05 -10 4.15 -10 0 -10 -4.15 -7.1 -7.05 -4.15 -10 0 -10 4.1 -10 7.05 -7.05 10 -4.15 10 -.05"/>
    </g>
  </g>]
  getViewBox = () => '0 0 24 24'
}
